import * as types from '../constants/actionTypes';

export const fetchVendorPerformanceRequest = (vendorId, params = {}) => ({
  type: types.FETCH_VENDOR_PERFORMANCE_REQUEST,
  payload: { vendorId, params },
});

export const fetchVendorPerformanceSuccess = (vendorId, data) => ({
  type: types.FETCH_VENDOR_PERFORMANCE_SUCCESS,
  payload: { vendorId, data },
});

export const fetchVendorPerformanceFailure = (error) => ({
  type: types.FETCH_VENDOR_PERFORMANCE_FAILURE,
  payload: error,
});

export const fetchAllVendorPerformanceRequest = (params = {}) => ({
  type: types.FETCH_ALL_VENDOR_PERFORMANCE_REQUEST,
  payload: params,
});

export const fetchAllVendorPerformanceSuccess = (data) => ({
  type: types.FETCH_ALL_VENDOR_PERFORMANCE_SUCCESS,
  payload: data,
});

export const fetchAllVendorPerformanceFailure = (error) => ({
  type: types.FETCH_ALL_VENDOR_PERFORMANCE_FAILURE,
  payload: error,
});
